import {Injectable} from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class CommonConstant{
  Client = {
    Resmac: "3894d42c-f70f-11ed-b67e-0242ac120002"

  }
  TaxonomyGroup = {
    LoanApplicationGroup: 101,

  }
  UserPermissionNounType ={
    Client : 101,
    Taxonomy : 102,
    Services : 103,
    User : 104,
    Role : 105,
    Permission : 106,
    Settings : 107,
    Branch : 108,
    Contacts : 109,
    LoanOriginatorDashboard :110,
    Training : 111,
    Reports : 112,
    DocumentType : 113,
    DocumentSet : 114,

  }
  UserPermissionVerbType ={
    Edit : 102,
    View : 101,
  }
  UserRoleName ={
    LoanOfficer : 'Loan Officer',
    Borrower : 'Borrower',
    Enterprise_Admin : 'Enterprise Admin',
  }
  ApplicantType={
    Borrower : 101,
  }
  LoanDocumentStatusType={
    Archived : 101,
    Locked : 102,
    UnLocked : 103,

  };
  CreateNewLoanType={
    Loan : '101',
    Lead : '102',


  };
  TransactionType ={
    Purchase : 101,
    Refinance : 102,

  };
  BorrowerActions = {
    BorrowerAddressInfo : 101,
    BorrowerAddressInfoEdit : 102,
    BorrowerAssets : 103,
    BorrowerAssetsEdit: 104,
    BorrowerDashboard : 105,
    BorrowerDashboardLoan : 106,
    BorrowerDeclaration : 107,
    BorrowerDeclarationEdit : 108,
    BorrowerDeclaration1 : 109,
    BorrowerDeclaration1Edit : 110,
    BorrowerDemographics : 111,
    BorrowerDemographicsEdit: 112,
    BorrowerEmploymentIncomePage1 : 113,
    BorrowerEmploymentIncomePage1Edit : 114,
    BorrowerEmploymentIncomePage2 : 115,
    BorrowerEmploymentIncomePage2Edit : 116,
    BorrowerEmploymentIncomePage3 : 117,
    BorrowerEmploymentIncomePage3Edit : 118,
    BorrowerMilitaryService : 119,
    BorrowerMilitaryServiceEdit :120,
    BorrowerREO : 121,
    BorrowerREOEdit : 122,
    BorrowerSubjectProperty : 123,
    BorrowerSubjectPropertyEdit : 124,
    LoanPurposeEdit : 125,
    BorrowerLoanDocumentEdit:126,
    BorrowerLiability: 127,
    BorrowerLiabilityEdit: 128,
    BorrowerInfo : 129,
    BorrowerInfoEdit : 130





  };
  SessionConstants ={
    PricingResults : 'PricingResults',
    SelectedRateOption : 'SelectedRateOption',
    SelectedQuote : 'SelectedQuote',
    SelectedProgramme :'SelectedProgramme'
  };



}
